import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "meetDriver"
const MeetDriverIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.5 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM9 10.41V22H5v-7H4V9a2 2 0 0 1 2-2h2c.27 0 .5.11.69.28l3.81 3.739 3.81-3.739c.19-.17.42-.28.69-.28h2a2 2 0 0 1 2 2v6h-1v7h-4V10.41L12.5 14 9 10.41ZM6.5 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
          />
        </svg>
      }
    </span>
  )
}
export default MeetDriverIcon
